import {Component, Input, Output, EventEmitter, OnInit, OnDestroy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PageButtonComponent} from '../buttons/page-button.component';
import {ThemeService} from '../../services/theme-service';
import {ActivatedRoute, Router} from '@angular/router';
import {AppStateService} from '../../services/app-state.service';
import {Subscription} from 'rxjs';
import {BorderIconButtonComponent} from '../buttons/border-icon-button.component';
import {TranslateService} from '../../services/translate.service';
import {BottomSheetService} from '../../services/bottom-sheet.service';
import { VenueConfig } from '../../models/FSConfig';

@Component({
  standalone: true,
  imports: [CommonModule, PageButtonComponent, BorderIconButtonComponent],
  selector: 'app-account-menu',
  template: `
    <div class="max-w-lg mx-auto bg-theme-surface-80 pb-safe w-full">
      <div class="flex flex-col gap-3 py-8">
        <app-border-icon-button *ngIf="showVouchers" icon="fa-ticket" [text]="translate.getString('Biljetter')" (onClick)="navVouchers()"></app-border-icon-button>
        <app-border-icon-button *ngIf="showTranslate" icon="fa-language" [text]="translate.getString('Språk')" (onClick)="navLangSelect()"></app-border-icon-button>
        <app-border-icon-button *ngIf="showLoyalty" icon="fa-crown" [text]="translate.getString('Lojalitetsprogram')" (onClick)="navLoyalty()"></app-border-icon-button>
        <app-border-icon-button icon="fa-user" [text]="isAnon ? translate.getString('Logga in') : translate.getString('Konto')" (onClick)="isAnon ? navLogin() : navAccount()"></app-border-icon-button>
        <app-border-icon-button icon="fa-receipt" [text]="translate.getString('Kvitton')" (onClick)="navReceipts()"></app-border-icon-button>
        <app-border-icon-button *ngIf="config?.payment?.prepaid_name" icon="fa-badge-percent" [text]="config!.payment!.prepaid_name!" (onClick)="displayPrepaid()"></app-border-icon-button>
<!--        <app-border-icon-button icon="fa-language" [text]="translate.getString('Språk')" (onClick)="navLang()"></app-border-icon-button>-->
        <!-- <app-border-icon-button icon="fa-clipboard-check" [text]="translate.getString('Settlement (test)')" (onClick)="navSettlement()"></app-border-icon-button>
        <app-border-icon-button icon="fa-solid fa-toilet-paper-slash" [text]="translate.getString('Button (previw)')" (onClick)="navButtonPreview()"></app-border-icon-button> -->
      </div>
    </div>
  `
})
export class AccountMenuComponent implements OnInit, OnDestroy {
  @Input() selectedPageId: string = '';
  @Output() onClick = new EventEmitter<MouseEvent>();
  private sub?: Subscription;
  isAnon?: boolean;
  isLoggedIn: boolean = false;
  config?: VenueConfig;
  showLoyalty: boolean = false;
  showTranslate: boolean = false;
  showVouchers: boolean = false;

  constructor(private themeService: ThemeService, private router: Router, private route: ActivatedRoute,
              private appStateService: AppStateService, protected translate: TranslateService,
              private sheetService: BottomSheetService) {}

  ngOnInit(): void {
    this.sub = this.appStateService.observeAppState().subscribe(appState => {
      // this.itemCount = MenuUtils.getItemCount(appState.order?.items);
      // const mustPay = appState.order?.user_cfg.payment?.open_order ?? true;
      // this.actionTitle = mustPay ? "Beställ och betala" : "Beställ";
      this.isAnon = appState.order.user_cfg.is_anon;
      this.isLoggedIn = !appState.order.user_cfg.is_anon;
      this.config = appState.cfg;
      const a = appState.cfg?.loyalty?.active ?? false;
      const ao = appState.cfg?.loyalty?.active_online ?? false;
      this.showLoyalty = a && ao;
      this.showTranslate = appState.cfg?.use_translations ?? false;
      this.showVouchers = appState.cfg?.voucher?.collins_voucher_mode === 'modern';
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  navAccount() {
    this.router.navigate([this.appStateService.venueId, "account"]);
    this.sheetService.popSheet();
  }

  navReceipts() {
    this.router.navigate([this.appStateService.venueId, "receipts"]);
    this.sheetService.popSheet();
  }

  navLang() {
    this.router.navigate([this.appStateService.venueId, "select-lang"]);
    this.sheetService.popSheet();
  }

  navLogin() {
    this.sheetService.displaySignin(2);
  }

  navButtonPreview() {
    this.router.navigate([this.appStateService.venueId, "button-preview"]);
    this.sheetService.popSheet();
  }

  payBill() {
    this.router.navigate([this.appStateService.venueId, "livesplit"]);
    this.sheetService.popSheet();
  }

  navSettlement() {
    this.router.navigate([this.appStateService.venueId, "settlement"]);
    this.sheetService.popSheet();
  }

  displayPrepaid() {
    this.sheetService.replaceSheet({sheetClass: "prepaid-card", title: this.translate.getString("Rabattkort")});
  }

  navLoyalty() {
    this.sheetService.replaceSheet({sheetClass: "loyalty-menu", title: this.translate.getString("Lojalitetsprogram")});
  }

  navLangSelect() {
    this.sheetService.replaceSheet({sheetClass: "select-lang", title: this.translate.getString("Språk")});
  }

  navVouchers() {
    this.router.navigate([this.appStateService.venueId, "vouchers"]);
    this.sheetService.popSheet();
  }

}
